// Helpers that reproduce how redux-form extracted values from change events.

export const isEvent = candidate => !!(
  candidate
  && typeof candidate.stopPropagation === 'function'
  && typeof candidate.preventDefault === 'function'
);

const getSelectedValues = options => Array.from(options || [])
  .filter(option => option.selected)
  .map(option => option.value);

export const getEventValue = (eventOrValue) => {
  if (!isEvent(eventOrValue)) {
    return eventOrValue;
  }
  const { target, dataTransfer } = eventOrValue;
  if (!target) {
    return undefined;
  }
  const {
    type,
    value,
    checked,
    files,
  } = target;
  if (type === 'checkbox') {
    return !!checked;
  }
  if (type === 'file') {
    return files || (dataTransfer && dataTransfer.files);
  }
  if (type === 'select-multiple') {
    return getSelectedValues(target.options);
  }
  return value;
};

// redux-form default format: null/undefined are shown as ''.
export const defaultFormat = value => (value === null || value === undefined ? '' : value);

// redux-form did not convert '' to undefined (final-form's default parse does).
export const identityParse = value => value;

// Field-level validate may be a function or an array of functions; the
// first error wins (redux-form semantics).
export const runFieldValidators = (validate, value, allValues, name) => {
  if (!validate) {
    return undefined;
  }
  const validators = Array.isArray(validate) ? validate : [validate];
  for (let index = 0; index < validators.length; index += 1) {
    const validator = validators[index];
    const error = typeof validator === 'function' ? validator(value, allValues, {}, name) : undefined;
    if (error) {
      return error;
    }
  }
  return undefined;
};
